import axios from 'axios';
import {useCallback, useEffect, useState} from 'react';

export const useGeoInfo = () => {
  const [userIPAddress, setUserIPAddress] = useState('');
  const [userCountry, setUserCountry] = useState('D_UK');
  const getUserGeoInfo = useCallback(async () => {
    try {
      const geoInfo = await axios('https://ipapi.co/json/');
      setUserIPAddress(geoInfo.data?.ip);
      setUserCountry(geoInfo.data?.country_code);
    } catch (e) {
      setUserIPAddress('');
      setUserCountry('D_UK');
    }
  }, []);

  useEffect(() => {
    getUserGeoInfo();
  }, [getUserGeoInfo]);

  return {userIPAddress, userCountry};
};
